import { useCallback } from "react";
import { trpc } from "../../../lib/api/trpc";
// import { UserDetail } from '@shared/schemas'; // Commented out as it's not used

/**
 * Hook for fetching a single user by ID
 */
export const useUser = (userId?: string) => {
  // Get the trpc context for revalidating queries
  // @ts-ignore - Type checking for trpc.useContext
  const utils = trpc.useContext();

  // Get user query (only if userId is provided)
  // @ts-ignore - Type checking for trpc.user property
  const {
    data: user,
    isLoading,
    isError,
    error,
    refetch,
  } = trpc.user.getUserById.useQuery(
    { id: userId! },
    {
      enabled: !!userId,
      staleTime: 30000, // 30 seconds
    },
  );

  // Function to invalidate user cache
  const invalidateUser = useCallback(() => {
    if (userId) {
      // @ts-ignore - Type checking for utils.user property
      return utils.user.getUserById.invalidate({ id: userId });
    }
  }, [
    userId,
    // @ts-ignore - Type checking for utils.user property
    utils.user.getUserById,
  ]);

  return {
    user,
    isLoading,
    isError,
    error,
    refetch,
    invalidateUser,
  };
};
